import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {LocalStorageService} from '../../../services/local-storage.service';
import {WALLET_AVATAR_TYPES, WalletAvatarType} from './wallet-avatar-type';
import {WalletAvatarPipe} from './wallet-avatar.pipe';

@Component({
    selector:        'wallet-avatar',
    templateUrl:     './wallet-avatar.component.html',
    styleUrl:        './wallet-avatar.component.scss',
    imports:         [
        WalletAvatarPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalletAvatarComponent {

    @Input()
    public address: string;

    @Input()
    public isChangeOnClickEnabled: boolean = false;

    public avatarType: WalletAvatarType = this.restoreAvatarType();

    public readonly WalletAvatarType = WalletAvatarType;

    private readonly storageKey = 'wallet-avatar-type';

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private localStorageService: LocalStorageService
    ) {}

    public onClickToggleAvatarType(event: MouseEvent): void {
        if (this.isChangeOnClickEnabled) {
            event.stopPropagation();
            event.preventDefault();

            this.toggleAvatarType();
        }
    }

    private toggleAvatarType(): void {
        const nextType = ((Number(this.avatarType) + 1) % WALLET_AVATAR_TYPES.length) as WalletAvatarType;

        this.setAvatarType(nextType);
    }

    private setAvatarType(type: WalletAvatarType) {
        this.avatarType = type;
        this.storeAvatarType();
        this.changeDetectorRef.markForCheck();
    }

    private restoreAvatarType(): WalletAvatarType {
        return this.localStorageService.get('wallet-avatar-type', WalletAvatarType.WALLET_AVATAR);
    }

    private storeAvatarType(): void {
        this.localStorageService.set('wallet-avatar-type', this.avatarType);
    }

}
